import styled from 'styled-components';

export const Content = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  border-radius: 10px;
  background: #393e44;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.58);
  width: ${(props) => props.width ?? 'auto'};
  height: ${(props) => props.height ?? 'auto'};
`;
